import api from './mainApi';

// Shared only while a viewer uses the image. No persistent image cache.
const activeImages = new Map();
export function acquireColorImage(colorId, version = '') {
  const key = JSON.stringify([String(colorId), version]);
  let entry = activeImages.get(key);
  if (!entry) {
    const controller = new AbortController();
    entry = { users: 0, controller };
    entry.promise = api.get(`/colors/${encodeURIComponent(colorId)}/image`, {
      signal: controller.signal, rejectOnCancel: true, timeout: 30000
    }).then(({ data }) => {
      if (String(data.colorId) !== String(colorId) ||
          (data.color !== null && typeof data.color !== 'string')) {
        throw new Error('Invalid color image response');
      }
      return data.color;
    });
    activeImages.set(key, entry);
  }
  entry.users++;
  let released = false;
  return {
    promise: entry.promise,
    release() {
      if (released) return;
      released = true;
      entry.users--;
      // Let React StrictMode immediately re-acquire the same request.
      queueMicrotask(() => {
        if (entry.users === 0 && activeImages.get(key) === entry) {
          activeImages.delete(key);
          entry.controller.abort();
        }
      });
    }
  };
}
